var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _vm.setUp === null
        ? _c("gg-loading", {
            attrs: {
              loading: true,
              type: "card"
            }
          })
        : !_vm.setUp
        ? _c("feature-setup", {
            attrs: {
              feature: "forwarders"
            },
            on: {
              create: function create($event) {
                _vm.creating = true
              }
            }
          })
        : _c("email-forwarders-table", {
            attrs: {
              title: "Forwarders",
              pending: _vm.pending
            },
            on: {
              update: _vm.loadForwarders
            },
            scopedSlots: _vm._u([
              {
                key: "header-actions",
                fn: function fn() {
                  return [
                    _c(
                      "gg-btn",
                      {
                        staticClass: "my-1",
                        attrs: {
                          secondary: "",
                          small: ""
                        },
                        on: {
                          click: function click($event) {
                            _vm.creating = true
                          }
                        }
                      },
                      [
                        _c(
                          "v-icon",
                          {
                            attrs: {
                              left: "",
                              small: ""
                            }
                          },
                          [_vm._v("mdi-plus")]
                        ),
                        _vm._v("Create Forwarder ")
                      ],
                      1
                    )
                  ]
                },
                proxy: true
              }
            ])
          }),
      _c("create-account-forwarder-modal", {
        attrs: {
          "is-active": _vm.creating,
          service: _vm.service,
          "scope-domain": _vm.$route.params.maindomain
        },
        on: {
          created: _vm.onCreated,
          close: function close($event) {
            _vm.creating = false
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }